<template>
  <Form ref="planForm" :model="plan" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >

    <input v-model="plan.id" type="hidden"/>
       <FormItem  :label="this.$t('common.plan.plateNo.label')" prop="plateNo">
         <Input v-model="plan.plateNo" @input="inputC" :placeholder="$t('common.plan.plateNo.holder')"/>
       </FormItem>

       <FormItem  :label="this.$t('common.plan.box.label')" prop="box">
         <Input v-model="plan.box" @input="inputB" :placeholder="$t('common.plan.box.holder')"/>
       </FormItem>

       <FormItem  :label="this.$t('common.plan.goodsName.label')" prop="goodsName">
         <Input v-model="plan.goodsName" :placeholder="$t('common.plan.goodsName.holder')"/>
       </FormItem>


       <FormItem  :label="this.$t('common.plan.type.label')" prop="type">
         <Select v-model="plan.type" :placeholder="this.$t('common.plan.type.holder')">
           <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
         </Select>
       </FormItem>

       <!--<FormItem  :label="this.$t('common.plan.status.label')" prop="status" >
         <i-switch size="large" v-model="plan.status"  :placeholder="this.$t('common.plan.status.holder')" >
            <span v-for="item in $t('common.plan.status.dictionary')" :value="item.value" :key="item.value" :slot="item.slot">{{ item.label }}</span>
         </i-switch>
       </FormItem>-->
    <div v-if="actionType!='add'">

        <FormItem  :label="this.$t('common.plan.status.label')" prop="status" >
            <i-switch size="large" v-model="plan.status"  :placeholder="this.$t('common.plan.status.holder')" :disabled="plan.status" >
             <span v-for="item in $t('common.plan.status.dictionary')" :value="item.value" :key="item.value" :slot="item.slot">{{ item.label }}</span>
          </i-switch>

        </FormItem>
      </div>
  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      plan: {
        id: null,
        plateNo: null,
        box: null,
        goodsName: null,
        gate: null,
        channel: null,
        crossTime: null,
        type: null,
        status: null,
      },
      loading: false,
      actionType:'add',
      typeList:[
        {
          value: 1,
          label: '入场'
        },
        {
          value: 2,
          label: '出场'
        },
      ]
    }
  },
  methods: {
    inputC(e) {
      console.log(e);
      if (!/^[A-Z\d]+$/.test(e)) { // 再进行转换，小写转为大写

        let val = e.toUpperCase();
        this.plan.plateNo = val
        return val
      }
    },
    inputB(e) {
      console.log(e);
      if (!/^[A-Z\d]+$/.test(e)) { // 再进行转换，小写转为大写

        let val = e.toUpperCase();
        this.plan.box = val
        return val
      }
    },
    planCorssTimeFormat(str,date){
      console.log(str);
      this.plan.crossTime = str ? str : ''
    },
    handleSubmit(then,error){
     // console.log(this.plan.type+"===============");
      this.$refs['planForm'].validate(valid => {
        if (valid) {
          if (this.plan.id) {
            this.updatePlan(this.plan).then(then).error(error)
          } else {
            this.createPlan(this.plan).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.plan.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['planForm'].resetFields());
    },
    getPlan(id,type){
      this.loading = true;
      this.$refs['planForm'].resetFields()
      api.common.Plan.detail(id).then(data => {
       // this.plan = data;
        console.log(data.box);
        this.plan.id = data.id;
        this.plan.plateNo = data.plateNo;
        this.plan.box = data.box;
        this.plan.goodsName = data.goodsName;
        this.plan.gate = data.gate;
        this.plan.channel = data.channel;
        this.plan.crossTime = data.crossTime;
        this.plan.type = data.type;
        this.plan.status = data.status;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createPlan(plan){
      this.loading = true;
      return api.common.Plan.add(plan)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updatePlan(plan){
      this.loading = true;
      return api.common.Plan.update(plan)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      plateNo: [{type: 'string', required: true, message: this.$t('common.plan.plateNo.required'),trigger: 'blur'}, {type: 'string',max: 10, message: this.$t('common.plan.plateNo.max'),trigger: 'blur'}],
      box: [{type: 'string',max: 255, message: this.$t('common.plan.box.max'),trigger: 'blur'}],
      type: [{type: 'number', required: true, message: this.$t('common.plan.type.required'),trigger: 'blur'}],
      status: [{type: 'boolean', required: true, message: this.$t('common.plan.status.required'),trigger: 'blur'}],
      }
      if(this.actionType == 'edit'){
        this.$refs['planForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
